export const IMAGE_SETTING_OPEN_VALUE = 515
export const IMAGE_SETTING_EXPANDED_OPEN_VALUE = window.innerHeight
export const IMAGE_SETTING_SCALE_TOOL_VALUE = 300
export const TEXT_SETTING_OPEN_VALUE = window.innerHeight
export const BACKGROUND_COLOR_SETTING_OPEN_VALUE = window.innerHeight - 130
export const LAYOUT_SETTINGS_OPEN_VALUE = window.innerHeight
